import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';
import {observer} from 'mobx-react';
import Spinner from 'react-spinkit';
import {useLoaderStore} from 'contexts/StoreContext';

export interface LoaderProps {}

const Loader = observer((props: LoaderProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const loaderStore = useLoaderStore();

  if (!loaderStore.isLoading) {
    return <></>;
  }

  return (
    <View style={styles.container}>
      <Spinner
        color={theme.colors.purple(1)}
        style={styles.spinner}
        name={'chasing-dots'}
      />
    </View>
  );
});

export default Loader;
